// import type { Login } from '@/js/model'
export const useLoginService = () => {
    const fetch = useFetch({ baseURL: '/api/getToken' })

    const login = (body: { username: string; password: string }) => {
        // return fetch.post<Login>({ body })
        return fetch.post<any>({ body })
    }

    return {
        login
    }
}
